import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TooltipModule } from 'primeng/tooltip';
import { BillingService } from '../../../../services/billing.service';

type RevioKpis = {
  customers: number;
  sites: number;
};

@Component({
  selector: 'app-revio-kpis',
  standalone: true,
  imports: [CommonModule, ProgressSpinnerModule, TooltipModule],
  templateUrl: './revio-kpis.component.html',
  styleUrls: ['./revio-kpis.component.scss'],
})
export class RevioKpisComponent implements OnInit {
  loading = false;
  error: string | null = null;

  data: RevioKpis = {
    customers: 0,
    sites: 0,
  };

  constructor(private readonly billing: BillingService) {}

  ngOnInit(): void {
    this.fetch();
  }

  private fetch(): void {
    this.loading = true;
    this.error = null;

    this.billing.getRevioStatistics().subscribe({
      next: (stats) => {
        this.data = {
          customers: stats.customers || 0,
          sites: stats.sites || 0,
        };
      },
      error: (err) => {
        this.error = (err?.message || 'Failed to load Rev.io statistics');
      },
      complete: () => (this.loading = false),
    });
  }
}
